<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                <v-icon class="me-2">mdi-filter</v-icon>
                Bonus Bank Advice Filter
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="handleFilterSubmit">
                  <v-row class="py-2 px-2" align="center" dense>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="filters.year"
                        :items="yearOptions"
                        label="Year"
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="filters.month"
                        :items="months"
                        item-title="label"
                        item-value="value"
                        label="Month"
                        variant="outlined"
                        density="compact"
                        clearable
                        hide-details="auto"
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="d-flex align-end ga-2">
                      <v-btn
                        type="submit"
                        color="primary"
                        :loading="loading"
                        prepend-icon="mdi-magnify"
                        class="pl-2"
                        density="compact"
                        height="40"
                        variant="flat"
                      >
                        Search
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
<!-- 
      <v-row class="mt-2" v-if="reportData.length > 0">
        <v-col cols="12" md="4">
          <v-card variant="outlined" color="primary">
            <v-card-text>
              <div class="text-caption text-medium-emphasis">Total Amount</div>
              <div class="text-h6 font-weight-bold">{{ formatNumber(summary.total_amount) }}</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card variant="outlined" color="success">
            <v-card-text>
              <div class="text-caption text-medium-emphasis">Employees</div>
              <div class="text-h6 font-weight-bold">{{ summary.total_employees }}</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card variant="outlined" color="info">
            <v-card-text>
              <div class="text-caption text-medium-emphasis">Banks</div>
              <div class="text-h6 font-weight-bold">{{ summary.total_banks }}</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->

      <v-row class="mt-2">
        <v-col cols="12">
          <v-expansion-panels v-model="listPanel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                <v-icon class="me-2">mdi-bank-transfer</v-icon>
                Bonus Bank Advice
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    />
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          :disabled="reportData.length === 0"
                        >
                          CSV
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          :disabled="reportData.length === 0"
                        >
                          EXCEL
                        </v-btn>
                        <v-btn
                          prepend-icon="mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          :disabled="reportData.length === 0"
                        >
                          PDF
                        </v-btn>
                      </v-btn-group>
                    </div>
                  </v-col>
                </v-row>

                <div v-if="!bankGroupsDetailed.length" class="py-6 text-center text-medium-emphasis">
                  <v-icon size="64" color="grey-lighten-1" class="mb-2">mdi-bank-off</v-icon>
                  <div class="text-h6 text-grey mt-4">No Bank Advice Found</div>
                  <div class="text-body-2 text-grey">Try adjusting filters or run a bonus payment via bank</div>
                </div>

                <div
                  v-for="bank in bankGroupsDetailed"
                  :key="bank.bank_key"
                  class="mb-6 bank-letter-card"
                >
                  <v-card variant="outlined">
                    <v-card-text>
                      <div class="letter-header">
                        <div>
                          <div class="company-name">{{ currentCompany.name || 'Company Name' }}</div>
                          <div class="text-body-2" v-if="currentCompany.address">{{ currentCompany.address }}</div>
                          <div class="text-body-2" v-if="currentCompany.mobile">Phone: {{ currentCompany.mobile }}</div>
                          <div class="text-body-2" v-if="currentCompany.email">Email: {{ currentCompany.email }}</div>
                        </div>
                        <div v-if="companyLogo" class="company-logo">
                          <img :src="companyLogo" alt="Company Logo" />
                        </div>
                      </div>

                      <div class="transfer-title">
                        Transfer of Fund against salary for employees
                      </div>

                      <div class="letter-meta">
                        <div></div>
                        <div>Date: {{ formatReportDate(new Date()) }}</div>
                      </div>

                      <div class="bank-info mb-4">
                        <div>The Manager</div>
                        <!-- <div class="font-weight-bold">{{ bank.bank_name }}</div>
                        <div v-if="bank.bank_sl">Branch: {{ bank.bank_sl }}</div> -->
                        <div v-if="bank.bank_account_name"> {{ bank.bank_account_name }}</div>
                        <div v-if="bank.bank_code">Bank Code: {{ bank.bank_code }}</div>
                      </div>

                      <div class="letter-body mb-4">
                        <p>Dear sir,</p>
                        <p>
                          Please arrange to transfer the following amount against the name of Officers' in their respective savings account with
                          various banks, by debiting our current account {{ getAccountReference(bank) }}, amounting to Tk. {{ formatNumber(bank.total_amount) }}
                          ({{ formatAmountInWords(bank.total_amount) }}) only against the salary for the month of {{ reportPeriodDisplay || '________' }}.
                        </p>
                      </div>

                      <div v-if="bank.bank_account_name" class="bank-title mb-2">
                        {{ bank.bank_account_name }}
                      </div>

                      <v-table class="bank-table" density="compact">
                        <thead>
                          <tr>
                            <th class="text-center">Sl. No.</th>
                            <th>ID No.</th>
                            <th>Name of the Employee</th>
                            <th>Designation</th>
                            <th>A/C. No.</th>
                            <th class="text-end">Amount (Taka)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(employee, idx) in bank.employees" :key="employee.id || idx">
                            <td class="text-center">{{ idx + 1 }}</td>
                            <td>{{ employee.employee_id_no }}</td>
                            <td>{{ employee.employee_name }}</td> 
                            <td>{{ employee.designation_name }}</td>
                            <td>{{ employee.account_number_display }}</td>
                           
                            <td class="text-end">{{ formatNumber(employee.amount) }}</td>
                          </tr>
                        
                          <tr class="totals-row">
                            <td></td>
                            <td colspan="4" class="text-end font-weight-bold">Total Tk.</td>
                            <td class="text-end font-weight-bold">{{ formatNumber(bank.total_amount) }}</td>
                          </tr>
                          <tr class="grand-row">
                            <td colspan="4" class="font-italic">
                              ({{ formatAmountInWords(bank.total_amount) }})
                            </td>
                            
                            <td class="text-end font-weight-bold">Grand Total Tk.</td>
                            <td class="text-end font-weight-bold">{{ formatNumber(grandTotal.value || bank.total_amount) }}</td>
                          </tr>
                        </tbody>
                      </v-table>

                      <div class="letter-footer mt-4">
                        <!-- <div v-if="bank.total_amount" class="text-body-2 mb-2">
                          <strong>Amount in Words:</strong> {{ formatAmountInWords(bank.total_amount) }}
                        </div> -->
                        <div class="signature-block">
                          <div>
                            <div class="signature-line"></div>
                            <div class="text-body-2">Authorized Signature</div>
                          </div>
                          <div>
                            <div class="signature-line"></div>
                            <div class="text-body-2">Accounts Department</div>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, reactive, computed, getCurrentInstance, onMounted } from 'vue'
import { toast } from 'vue3-toastify'
import { useStore } from 'vuex'
import convertNumberToWords from '@/plugins/numberToWord'

const instance = getCurrentInstance()
const appContext = instance?.appContext
const store = useStore()
const panel = ref([0])
const listPanel = ref([0])
const loading = ref(false)
const search = ref('')
const reportData = ref([])
const grandTotal = ref(0)
const grandTotalInWords = ref('')
const designationsMap = ref({}) // Map of designation_id to designation name

// Options
const months = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 }
]

// Generate year options (from 2020 to current year + 5)
const currentYear = new Date().getFullYear()
const yearOptions = computed(() => {
  const years = []
  for (let year = 2020; year <= currentYear + 5; year++) {
    years.push(year)
  }
  return years.reverse()
})

// Data
const filters = reactive({
  year: null,
  month: null
})

const normalizeResponseData = (data) => {
  if (!data) return []
  if (Array.isArray(data)) return data
  if (typeof data === 'object') {
    return Object.values(data).flat()
  }
  return []
}

// Computed
const filteredReportData = computed(() => {
  if (!search.value || !search.value.trim()) return reportData.value
  const term = search.value.toLowerCase().trim()
  return reportData.value.filter(item => {
    const haystack = [
      item.bank_name,
      item.bank_code,
      item.employee_bank_name,
      item.account_number_display,
      item.employee_code,
      item.employee_id_no,
      item.employee_name,
      item.designation_name
    ].join(' ').toLowerCase()
    return haystack.includes(term)
  })
})

const bankGroupsDetailed = computed(() => {
  if (!filteredReportData.value.length) return []

  const groups = {}
  filteredReportData.value.forEach((item) => {
    // Group by payment_account_head_id (company's bank account)
    const key = item.payment_account_head_id || 'unassigned'
    if (!groups[key]) {
      groups[key] = {
        bank_key: key,
        bank_name: item.bank_name, // This is now payment_account_head.name
        bank_code: item.bank_code, // This is now payment_account_head.code
        bank_account_name: item.bank_account_name || item.bank_name || '',
        bank_account_number: item.bank_account_number || null,
        bank_sl: item.bank_sl || '',
        total_amount: 0,
        employees: []
      }
    }
    groups[key].total_amount += Number(item.amount || 0)
    groups[key].employees.push(item)
  })

  return Object.values(groups)
})

const summary = computed(() => {
  if (!filteredReportData.value || filteredReportData.value.length === 0) {
    return {
      total_amount: 0,
      total_employees: 0,
      total_banks: 0
    }
  }

  return {
    total_amount: filteredReportData.value.reduce((acc, item) => acc + Number(item.amount || 0), 0),
    total_employees: filteredReportData.value.length,
    total_banks: bankGroupsDetailed.value.length
  }
})

// Methods
const fetchBonusBankAdvice = async () => {
  loading.value = true
  try {
    const sanitizedFilters = Object.fromEntries(
      Object.entries(filters).filter(([, value]) => value !== null && value !== '')
    )
    const response = await store.dispatch('getBonusBankAdviceReport', sanitizedFilters)

    if (response.data.success) {
      const normalized = normalizeResponseData(response.data.data)
      
      // Debug: Log first item to see structure
      if (normalized.length > 0) {
        console.log('Sample API response item:', normalized[0])
      }
      
      reportData.value = normalized.map(item => {
        const paymentMaster = item.payment_master || item.paymentMaster || {}
        const paymentAccountHead = paymentMaster.payment_account_head || paymentMaster.paymentAccountHead || {}
        const paymentMonth =
          paymentMaster.month ??
          paymentMaster.month_id ??
          item.payment_month ??
          item.month ??
          null
        const paymentYear =
          paymentMaster.year ??
          item.payment_year ??
          item.year ??
          null
        const derivedAccountNumber =
          paymentAccountHead.account_number ??
          paymentAccountHead.accountNo ??
          paymentAccountHead.account_no ??
          (paymentAccountHead.name ? paymentAccountHead.name.match(/(\d+)/)?.[0] : null)

        // Try multiple paths for account_number (handle empty strings)
        let accountNumber = '—'
        if (item.account_number && item.account_number.trim() !== '') {
          accountNumber = item.account_number
        } else if (item.accountNumber && item.accountNumber.trim() !== '') {
          accountNumber = item.accountNumber
        } else if (item.account_no && item.account_no.trim() !== '') {
          accountNumber = item.account_no
        } else if (item.bankInfo?.account_number) {
          accountNumber = item.bankInfo.account_number
        } else if (item.employee?.bankInfo?.account_number) {
          accountNumber = item.employee.bankInfo.account_number
        }

        // Try multiple paths for designation, including lookup from designationsMap
        const designationName = 
          item.designation?.name ||
          item.designation_name ||
          item.employee?.designation?.name ||
          item.employee?.designation_name ||
          item.bonusProcessDetail?.designation?.name ||
          item.bonus_process_detail?.designation?.name ||
          (item.designation_id && designationsMap.value[item.designation_id]?.name) ||
          '—'

        return {
          ...item,
          // Employee's bank info (for employee account details)
          employee_bank_name: item.bank?.name || 'Unassigned Bank',
          employee_bank_sl: item.bank?.sl || '',
          // Payment account head info (for "The Manager" section)
          payment_account_head_id:
            paymentMaster.payment_account_head_id ||
            paymentAccountHead.id ||
            null,
          bank_name: paymentAccountHead.name || 'Unassigned Bank',
          bank_code: paymentAccountHead.code || '—',
          bank_account_name: paymentAccountHead.name || '',
          bank_account_number: derivedAccountNumber || null,
          bank_sl: paymentAccountHead.sl || '',
          account_number_display: accountNumber,
          employee_code: item.employee?.code || '—',
          employee_name: item.employee?.name || '—',
          employee_id_no: item.employee?.code || '—',
          designation_name: designationName,
          payment_month: paymentMonth !== null && paymentMonth !== undefined ? Number(paymentMonth) : null,
          payment_year: paymentYear !== null && paymentYear !== undefined ? Number(paymentYear) : null
        }
      })
      grandTotal.value = response.total || summary.value.total_amount
      grandTotalInWords.value = response.total_in_words || ''
    } else {
      reportData.value = []
      grandTotal.value = 0
      grandTotalInWords.value = ''
      toast.error(response.message || 'Failed to load bonus bank advice')
    }
  } catch (error) {
    reportData.value = []
    grandTotal.value = 0
    grandTotalInWords.value = ''
    const errorMessage = error.response?.data?.message || error.message || 'Failed to load bonus bank advice'
    toast.error(errorMessage)
  } finally {
    loading.value = false
  }
}

const handleFilterSubmit = () => {
  fetchBonusBankAdvice()
}

const formatNumber = (value, fraction = 2) => {
  if (value === undefined || value === null || value === '' || isNaN(value)) return '0.00'
  return Number(value).toLocaleString(undefined, {
    minimumFractionDigits: fraction,
    maximumFractionDigits: fraction
  })
}

// Computed for company info
const currentCompany = computed(() => {
  return store.getters.getCurrentCompany || {}
})

const getFileServerUrl = computed(() => {
  return store.getters.getFileServerUrl || ''
})

const companyLogo = computed(() => {
  if (!currentCompany.value?.logo_thumb || !getFileServerUrl.value) return ''
  return `${getFileServerUrl.value}${currentCompany.value.logo_thumb}`
})

const formatReportDate = (date) => {
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }).format(date)
}

const formatMonthName = (monthValue) => {
  if (!monthValue) return ''
  const monthObj = months.find(m => m.value === monthValue)
  return monthObj ? monthObj.label : ''
}

const extractAccountNumber = (accountName) => {
  if (!accountName) return ''
  // Try to extract account number from strings like "DDBL  A/C 1000243434"
  const match = accountName.match(/(\d+)/)
  return match ? match[1] : ''
}

const formatAmountInWords = (amount) => {
  if (!amount || amount === 0) return 'Zero Taka Only.'
  
  // Use the grandTotalInWords if available and amount matches grand total
  if (grandTotalInWords.value && Math.abs(Number(amount) - grandTotal.value) < 0.01) {
    return grandTotalInWords.value
  }
  
  // Use the convertNumberToWords plugin
  try {
    const words = convertNumberToWords(amount)
    return words || `${formatNumber(amount)} Taka Only.`
  } catch (error) {
    console.error('Error converting number to words:', error)
    return `${formatNumber(amount)} Taka Only.`
  }
}

const getAccountReference = (bank) => {
  if (!bank) return 'No. 07'
  const accountNumber =
    bank.bank_account_number ||
    extractAccountNumber(bank.bank_account_name || '')

  if (accountNumber) {
    return `No. ${accountNumber}`
  }

  if (bank.bank_account_name) {
    return bank.bank_account_name
  }

  return 'No. 07'
}

const reportPeriodMonth = computed(() => {
  if (filters.month) {
    const monthValue = Number(filters.month)
    return Number.isNaN(monthValue) ? '' : formatMonthName(monthValue)
  }

  const itemWithMonth = reportData.value.find(entry => entry.payment_month)
  if (itemWithMonth?.payment_month) {
    return formatMonthName(Number(itemWithMonth.payment_month))
  }

  return ''
})

const reportPeriodYear = computed(() => {
  if (filters.year) return filters.year
  const itemWithYear = reportData.value.find(entry => entry.payment_year)
  if (itemWithYear?.payment_year) {
    return itemWithYear.payment_year
  }
  return ''
})

const reportPeriodDisplay = computed(() => {
  const monthLabel = reportPeriodMonth.value
  const yearValue = reportPeriodYear.value

  if (monthLabel && yearValue) {
    return `${monthLabel}, ${yearValue}`
  }

  if (monthLabel) return monthLabel
  if (yearValue) return `${yearValue}`
  return ''
})

// Export functions
const exportToCSV = () => {
  if (!reportData.value || reportData.value.length === 0) {
    toast.warning('No data to export')
    return
  }

  const data = [
    ['Bonus Bank Advice'],
    [`Year: ${filters.year || 'All'}`],
    [`Month: ${filters.month ? months.find(m => m.value === filters.month)?.label : 'All'}`]
  ]

  bankGroupsDetailed.value.forEach((bank, groupIndex) => {
    data.push([])
    data.push([`Bank: ${bank.bank_name}`])
    data.push([], ['Sl. No.', 'ID No.', 'Name of the Employee', 'Designation', 'A/C. No.', 'Amount (Taka)'], [])
    bank.employees.forEach((employee, idx) => {
      data.push([
        idx + 1,
        employee.employee_id_no,
        employee.employee_name,
        employee.designation_name,
        employee.account_number_display,
        formatNumber(employee.amount)
      ])
    })
    data.push(['', '', '', 'Total Tk.', '', formatNumber(bank.total_amount)])
    data.push(['', '', `(${formatAmountInWords(bank.total_amount)})`, '', 'Grand Total Tk.', formatNumber(grandTotal.value || bank.total_amount)])
    if (groupIndex !== bankGroupsDetailed.value.length - 1) {
      data.push([])
    }
  })

  const proxy = appContext?.config?.globalProperties
  if (proxy?.$exportTableToCSV && proxy?.$fileDate) {
    proxy.$exportTableToCSV(data, 'bonus_bank_advice_' + proxy.$fileDate())
  }
}

const exportToExcel = () => {
  if (!reportData.value || reportData.value.length === 0) {
    toast.warning('No data to export')
    return
  }

  const data = [
    ['Bonus Bank Advice'],
    [`Year: ${filters.year || 'All'}`],
    [`Month: ${filters.month ? months.find(m => m.value === filters.month)?.label : 'All'}`]
  ]

  bankGroupsDetailed.value.forEach((bank, groupIndex) => {
    data.push([])
    data.push([`Bank: ${bank.bank_name}`])
    data.push([], ['Sl. No.', 'ID No.', 'Name of the Employee', 'Designation', 'A/C. No.', 'Amount (Taka)'], [])
    bank.employees.forEach((employee, idx) => {
      data.push([
        idx + 1,
        employee.employee_id_no,
        employee.employee_name,
        employee.designation_name,
        employee.account_number_display,
        formatNumber(employee.amount)
      ])
    })
    data.push(['', '', '', 'Total Tk.', '', formatNumber(bank.total_amount)])
    data.push(['', '', `(${formatAmountInWords(bank.total_amount)})`, '', 'Grand Total Tk.', formatNumber(grandTotal.value || bank.total_amount)])
    if (groupIndex !== bankGroupsDetailed.value.length - 1) {
      data.push([])
    }
  })

  const proxy = appContext?.config?.globalProperties
  if (proxy?.$exportTableToExcel && proxy?.$fileDate) {
    proxy.$exportTableToExcel(data, 'bonus_bank_advice_' + proxy.$fileDate())
  }
}

const exportToPDF = async () => {
  if (!reportData.value || reportData.value.length === 0) {
    toast.warning('No data to export')
    return
  }

  const company = currentCompany.value
  const fileServerUrl = getFileServerUrl.value
  const logo = company?.logo_thumb ? `${fileServerUrl}${company.logo_thumb}` : ''

  let printWindow = window.open('', 'PRINT', `width=${screen.width}, height=${screen.height}, left=0, top=0`)
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <meta http-equiv="X-UA-Compatible" content="ie=edge">
        <title>Bonus Bank Advice</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400..700;1,400..700&display=swap" rel="stylesheet">
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet">
        <style>
          body { font-family: 'Arimo', sans-serif; margin: 0px; }
          .invoice-header { display:flex; justify-content:space-between; align-items:center; border-bottom:2px solid #eee; padding-bottom:10px; }
          .invoice-header img { max-height: 70px; max-width: 150px; }
          .letter-meta { display:flex; justify-content:space-between; font-size: 13px; margin-top: 12px; }
          .bank-section { page-break-inside: avoid; margin-top: 32px;  }
          .letter-bank-info { margin-top: 12px; font-size: 14px; }
          .letter-body { margin-top: 12px; font-size: 14px; }
          .table th, .table td { border: 1px solid #000; padding: 8px; vertical-align: middle; font-size: 12px; }
          .table th { background-color: #f0f0f0; color: #333; }
          .text-end { text-align: right; }
          .text-center { text-align: center; }
          h4 { font-size: 20px; color: #333; }
          p { font-size: 14px; color: #555; margin: 2px 0; }
          strong { font-weight: bold; color: #333; }
          @page { margin: 0.5in; size: letter; }
          .signature-line { width: 200px; border-top: 1px solid #333; margin-top: 40px; }
        </style>
      </head>
      <body>
        <div class="container-fluid position-relative">
          <div class="invoice-header">
            <div>
              <h4 class="text-uppercase">${company?.name || 'Company Name'}</h4>
              <p style="width:65%">${company?.address || ''}</p>
              <p><i class="mdi mdi-phone-outline"></i> ${company?.mobile || ''}</p>
              <p><i class="mdi mdi-email-outline"></i> ${company?.email || ''}</p>
              ${company?.website ? `<p><i class="mdi mdi-web"></i> ${company.website}</p>` : ''}
            </div>
            <div class="logo-container">
              ${logo ? `<img src="${logo}" alt="Logo" class="img-fluid">` : ''}
            </div>
          </div>
          ${bankGroupsDetailed.value.map(bank => `
            <div class="bank-section">
              <div class="transfer-title" style="font-weight: 600; font-size: 16px; padding: 12px 0; text-align: center;  margin-bottom: 12px;">
                Transfer of Fund against salary for employees
              </div>
              <div class="letter-meta">
                <div></div>
                <div>Date: ${formatReportDate(new Date())}</div>
              </div>
              <div class="letter-bank-info">
                <p><strong>The Manager</strong></p>
                ${bank.bank_account_name ? `<p>${bank.bank_account_name}</p>` : ''}
                ${bank.bank_code ? `<p>Bank Code: ${bank.bank_code}</p>` : ''}
              </div>
              <div class="letter-body">
                <p>Dear sir,</p>
                <p>
                  Please arrange to transfer the following amount against the name of Officers' in their respective savings account with
                  various banks, by debiting our current account ${getAccountReference(bank)}, amounting to Tk. ${formatNumber(bank.total_amount)}
                  (${formatAmountInWords(bank.total_amount)}) only against the salary for the month of ${reportPeriodDisplay.value || '________'}.
                </p>
              </div>
              ${bank.bank_account_name ? `<h5 class="mt-3">${bank.bank_account_name}</h5>` : ''}
              <table class="table mt-2">
                <thead>
                  <tr>
                    <th>Sl. No.</th>
                    <th>ID No.</th>
                    <th>Name of the Employee</th>
                    <th>Designation</th>
                    <th>A/C. No.</th>
                    <th class="text-end">Amount (Taka)</th>
                  </tr>
                </thead>
                <tbody>
                  ${bank.employees.map((employee, idx) => `
                    <tr>
                      <td>${idx + 1}</td>
                      <td>${employee.employee_id_no}</td>
                      <td>${employee.employee_name}</td>
                      <td>${employee.designation_name}</td>
                      <td>${employee.account_number_display}</td>
                      <td class="text-end">${formatNumber(employee.amount)}</td>
                    </tr>
                  `).join('')}
                  <tr>
                    <td></td>
                    <td colspan="4" class="text-end"><strong>Total Tk.:</strong></td>
                    <td class="text-end"><strong>${formatNumber(bank.total_amount)}</strong></td>
                  </tr>
                  <tr>
                    <td colspan="4"><em>(${formatAmountInWords(bank.total_amount)})</em></td>
                    <td class="text-end"><strong>Grand Total Tk.:</strong></td>
                    <td class="text-end"><strong>${formatNumber(grandTotal.value || bank.total_amount)}</strong></td>
                  </tr>
                </tbody>
              </table>
              ${bank.total_amount ? `<p class="mt-2"><strong>Amount in Words:</strong> ${formatAmountInWords(bank.total_amount)}</p>` : ''}
              <div style="display:flex; justify-content:space-between; margin-top:32px;">
                <div style="width:200px; border-top:1px solid #9e9e9e;"></div>
                <div style="width:200px; border-top:1px solid #9e9e9e;"></div>
              </div>
              <div style="display:flex; justify-content:space-between; margin-top:4px;">
                <div>Authorized Signature</div>
                <div>Accounts Department</div>
              </div>
            </div>
          `).join('')}
        </div>
      </body>
    </html>
  `)
  printWindow.moveTo(0, 0)
  printWindow.focus()
  await new Promise(resolve => setTimeout(resolve, 500))
  printWindow.print()
  printWindow.close()
}

// Fetch designations to create a map
const fetchDesignations = async () => {
  try {
    const response = await store.dispatch('getDesignations')
    if (response.data.success && response.data.data) {
      // Create a map of id to designation object
      const map = {}
      response.data.data.forEach(designation => {
        map[designation.id] = designation
      })
      designationsMap.value = map
    }
  } catch (error) {
    console.error('Error fetching designations:', error)
  }
}

// Initialize
onMounted(async () => {
  await fetchDesignations() // Load designations first
  // fetchBonusBankAdvice()
})
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
.bank-letter-card {
  border: 1px solid #e0e0e0;
}
.letter-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}
.company-name {
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
}
.company-logo img {
  max-height: 64px;
  max-width: 150px;
  object-fit: contain;
}
.transfer-title {
  font-weight: 600;
  font-size: 1rem;
  padding: 12px 0;

  margin-bottom: 12px;
  text-align: center;
}
.letter-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  margin: 16px 0;
  border-top: 1px solid #ececec;
  border-bottom: 1px solid #ececec;
  padding: 8px 0;
}
.bank-info {
  font-size: 0.95rem;
  line-height: 1.4;
}
.letter-body {
  font-size: 0.95rem;
  color: #555;
}
.bank-table {
  margin-top: 12px;
  border: 1px solid #b0bec5;
  border-radius: 4px;
  overflow: hidden;
}
.bank-table table {
  border-collapse: collapse;
  width: 100%;
}
.bank-table th,
.bank-table td {
  border: 1px solid #b0bec5;
}
.bank-title {
  font-weight: 600;
  font-size: 1rem;
}
.bank-table th {
  background-color: #f6f8fa !important;
  font-weight: 600;
}
.bank-table td {
  font-size: 0.95rem;
}
.totals-row td {
  background-color: #f5f5f5 !important;
  font-weight: 600;
}
.grand-row td {
  background-color: #fff;
  border-top: none;
  font-weight: 600;
}
.signature-block {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 32px;
  margin-top: 32px;
  width: 100%;
}
.signature-line {
  width: 200px;
  border-top: 1px solid #9e9e9e;
  margin-bottom: 4px;
}
</style>


